export default class ReportEnvironment {
  static env() {
    if(typeof(window.player) == 'undefined') return null;

    if(typeof(window.player.env) ==  'undefined') return null;

    return window.player.env();
  }

  static platform() {
    if(this.env() == null) return null;

    return this.env().platform();
  }

  static deviceModel() {
    if(this.env() == null) return null;

    return this.env().deviceModel();
  }

  static deviceId() {
    if(this.env() == null) return null;

    return this.env().deviceVendor();
  }

  static appVersion() {
    if(typeof(window.playback) == 'undefined') return null;

    if(typeof(window.playback.Revision) == 'undefined') return null;

    return window.playback.Revision.tag;
  }
}